module.exports = __webpack_public_path__ + "static/media/benefit-fast@3x.c873f287.png";